<script>
    import notifier from "../stores/notifier";
    import {fade, fly} from 'svelte/transition';
    import EmbeddedIcon from "./icons/EmbeddedIcon.svelte";
</script>

{#if $notifier.length}
    <div class="notifier">
        {#each $notifier as msg}
            <div class="notifier-msg {msg.type}" in:fly="{{ y: 20, duration: 200 }}" out:fade="{{ duration: 200 }}">
                    <span class="icon">
                        {#if msg.type === 'notifier-notice'}
                            <EmbeddedIcon icon="check-circle" size="20" strokeWidth="2"/>
                        {:else}
                            <EmbeddedIcon icon="alert-circle" size="20" strokeWidth="2"/>
                        {/if}
                    </span>
                {msg.message}
            </div>
        {/each}
    </div>
{/if}

<style>
    .notifier {
        position: fixed;
        bottom: 10px;
        right: 10px;
        margin: 10px;
        z-index: 9999;
    }

    .notifier .notifier-msg {
        min-width: 300px;
        font-size: 1rem;
        border-radius: 2px;
        padding: 10px 10px;
        margin: 5px;
    }

    .notifier .notifier-msg .icon {
        display: inline-block;
        line-height: 1;
        margin-right: 5px;
    }

    .notifier .notifier-notice {
        color: #fff;
        background: #4caf50;
    }

    .notifier .notifier-error {
        color: #fff;
        background: #f44336;
    }
</style>